if (!customElements.get("custom-swiper")) {
  customElements.define(
    "custom-swiper",

    class CustomSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperId = this.getAttribute("id");
        this.swiperOptions = JSON.parse(
          this.querySelector("[id^=SwiperOptions]").innerHTML
        );
        this.swiper = new Swiper(
          `#${this.swiperId} .swiper`,
          this.swiperOptions
        );

        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!event.el.closest("custom-swiper")) return;

          if (event.el.closest("custom-swiper").id !== this.swiperId) return;
          this.swiper.update();
        });
      }
    }
  );
}
